import { Row, Typography } from 'antd'
import KCard from 'app/components/UI-Elements/DataDisplay/KCard'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { useQuery } from 'app/lib/hooks/useQuery'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import { queries } from 'app/queries'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import MachineHeader from '../Containers/MachineHeader'
import ProjectCard from '../Containers/ProjectCard'

const { Text } = Typography

const MachineShow: React.FC<PageProps> = (props) => {
  const { titlelizer } = useTitle(props)
  const { machine_id } = useParams<{ machine_id: string }>()
  const { data, loading } = useQuery<{ lineItem: ILineItem }>(queries.lineItem.get, {
    skip: !machine_id,
    variables: {
      id: machine_id,
      includeCategorySegment: true,
      includeSubItems: true,
      withFinancials: true
    }
  })
  const machine = data?.lineItem

  useEffect(() => {
    titlelizer({ name: machine?.name })
  }, [machine])

  return (
    <Row gutter={[{ xs: 0, md: 12 }, 12]}>
      <KCol xs={24} lg={16}>
        <Row gutter={[{ xs: 0, md: 12 }, 12]}>
          <KCol span={24} card loading={loading}>
            <MachineHeader member={machine} />
          </KCol>
          <KCol span={24} card title="Machine Information" loading={loading}>
            <Text>TODO: Show machine information</Text>
          </KCol>
          {/* Damages and other section would go here */}
        </Row>
      </KCol>
      <KCol xs={24} lg={8} loading={loading}>
        <KCard
          title="Project"
          variant="borderless"
          classNames={{
            body: 'pt-0'
          }}>
          <ProjectCard member={machine} />
        </KCard>
      </KCol>
    </Row>
  )
}

export default MachineShow
